export var SelectionActionTypes = /*#__PURE__*/function (SelectionActionTypes) {
  SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
  SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
  return SelectionActionTypes;
}({});